import { onMounted, onBeforeUnmount } from 'vue'
import { EventBus } from '@/event-bus'
import { Events } from '@/models/events.model'
import { Handler } from 'mitt'
import RappidContext from '@/pages/explorer/rappid/rappid-context'

import notifMessage from '@/translations/notifMessage.json'
import * as HELPERS from '@/utils/helpers'

export function useEventBus<Key extends keyof Events>(event: Key, callback: Handler<Events[Key]>) {
  onMounted(() => {
    EventBus.on(event, callback)
  })
  onBeforeUnmount(() => {
    EventBus.off(event, callback)
  })
}

/**
 * Wrap an event handler in two calls to freeze and unfreeze the rappid context
 */
export const freezeWrap =
  <T>(callback: (event: T) => Promise<void>, rappidContext: RappidContext) =>
  async (args: T) => {
    rappidContext.paper.freeze()

    try {
      await callback(args)
    } finally {
      rappidContext.paper.unfreeze()
    }
  }

/**
 * Wrap an event handler a try catch block
 */
export const tryWrap =
  <T>(callback: (event: T) => Promise<void>, errorCallback?: (error: unknown) => void) =>
  async (args: T) => {
    try {
      await callback(args)
    } catch (error: unknown) {
      if (errorCallback) {
        errorCallback(error)
      } else {
        HELPERS.showTopAlertMessage(true, 'error', notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG)
      }
    }
  }
